/* istanbul ignore file */
import React from 'react'
// @ts-ignore no types
import _ from 'lodash'
import classnames from 'classnames/bind'
import * as constants from '@adc/constants'
import {
  Grid,
  useApplicationContext,
  useApplicationModals,
  // @ts-ignore no types
} from '@adc/ui-adc'
import { useListingContext } from 'common/context/listing'
// @ts-ignore no types
import { withModalHooks } from 'common/hooks/useModalFeatures'
import { useContactModal } from 'common/modules/propertyDetails/useContactModal'
import { formatPhoneNumber } from 'common/utils/formatters'
import AuctionDetails from 'common/modules/auctionDetails'
import { getContactAgentInfo } from 'common/utils/listing'
import TermsCard from './termsCard'
import SaleTermBadges from './termBadges'
import PropertyDescription from './propertyDescription'
import cls from './styles.scss'

const cx = classnames.bind(cls)

interface SaleTermsPropsType {
  toggleAuthModal: () => void
  pushOnboardingQueueItem: (args: any[]) => void
}

export const SALE_TERMS_ELM_ID = 'sale_terms'

export const SaleTerms = ({
  toggleAuthModal,
  pushOnboardingQueueItem,
}: SaleTermsPropsType) => {
  const { listing } = useListingContext()

  const { user } = useApplicationContext()
  const applicationModal = useApplicationModals()
  const contactModal = useContactModal({ user })
  const brokerAgent = getContactAgentInfo(listing)
  const canRequestPrivateTour = Boolean(
    listing.listing_configuration?.are_private_tours_available
  )
  const openHouseInfo = listing.open_houses
  const hasPrivateAgent = Boolean(brokerAgent?.agentEmail)
  const hasOpenHouses = Boolean(openHouseInfo?.length)
  const openContactModal = () => {
    setTimeout(() => contactModal.open(), 10)
  }

  const toggleContactModalIfAble = () => {
    if (hasPrivateAgent) {
      if (user.logged_in) {
        openContactModal()
      } else {
        toggleAuthModal()
        pushOnboardingQueueItem([openContactModal])
      }
    } else {
      applicationModal.open('confirmation', {
        title: 'Licensed agents only',
        children: `Please contact ${formatPhoneNumber(
          constants.contactNumbers.INTERIOR_ACCESS_NUMBER
        )} for details.`,
        confirmText: 'Close',
        hideCancelButton: true,
      })
    }
  }

  return (
    <div id={SALE_TERMS_ELM_ID} data-elm-id={SALE_TERMS_ELM_ID}>
      <Grid>
        <Grid.Row>
          <Grid.Column computer={10} mobile={16}>
            <Grid>
              <Grid.Row>
                <Grid.Column computer={16}>
                  <div className={cx('term-list-and-description')}>
                    <PropertyDescription />
                    <SaleTermBadges />
                  </div>
                </Grid.Column>
              </Grid.Row>
              {hasOpenHouses || hasPrivateAgent || canRequestPrivateTour ? (
                <TermsCard
                  openHouseInfo={openHouseInfo}
                  elmId={SALE_TERMS_ELM_ID}
                  openContactModal={toggleContactModalIfAble}
                  brokerAgent={brokerAgent}
                  canRequestPrivateTour={canRequestPrivateTour}
                />
              ) : (
                ''
              )}
            </Grid>
          </Grid.Column>
          <Grid.Column computer={6} mobile={16}>
            <div style={{ minHeight: 300 }}>
              <AuctionDetails displayInline />
            </div>
          </Grid.Column>
        </Grid.Row>
      </Grid>
    </div>
  )
}

export default withModalHooks(SaleTerms)
